import { useChangelog } from '../../../store/global/useChangelog';
import { formatResponses } from '../../formatResponses/changelog';


export class ChangelogModel {
  changelogAction = useChangelog.getState().actions

  findChangelog() {
    try {
      const formattedChangelogs = formatResponses.changelogs(window?.Headway.iframeData)
      this.changelogAction.setLogs(formattedChangelogs)
      return formattedChangelogs
    } catch (error) {
      console.error(error)
    }
  }
  setChangelogs(changelogData) {
    try {
      const formattedChangelogs = formatResponses.changelogs(changelogData)
      this.changelogAction.setLogs(formattedChangelogs)
      return formattedChangelogs
    } catch (error) {
      console.error(error)
    }
  }
}
